import {RadioGroup} from '@smart/react-components';
import React, {useMemo} from 'react';
import type {Maybe} from '../../graphql';
import {useSchemas} from '../hooks/user-schemas';
import Intercept from './easy-form/Intercept';
import Fields from './easy-form/fields';
import type {preValidationTransform} from './easy-form/types';
import {useFieldSetup} from './easy-form/use-field-setup';

interface IProps {
  tag: string;
  options: string[];
  optionsLabel?: Maybe<string | undefined>[];
  initial?: string;
  set?: boolean;
  hideLegend?: boolean;
  required?: boolean;
  label?: Maybe<string>;
}

const MultiRadio = function ({
  tag,
  options,
  initial = ``,
  set = true,
  hideLegend = false,
  required = false,
  optionsLabel,
  label,
}: IProps) {
  const generalSchemas = useSchemas();

  const transform: preValidationTransform = (merge) => {
    const choice = Object.entries(merge).reduce(
      (prev, pair) => (pair[1]! > prev[1]! ? pair : prev),
      [``, 0],
    );
    return choice[0] || undefined;
  };

  const schema = useMemo(
    () => generalSchemas.oneOf([...options], required),
    [options],
  );

  useFieldSetup(tag, initial, schema);

  return (
    <Intercept
      label={label}
      set={set}
      tag={tag}
      required={required}
      block="messages"
      schema={schema}
      outputTransform={transform}
      hideLegend={hideLegend}
    >
      <RadioGroup name={tag} required={required}>
        {options.map((optionTag, optionIndex) => {
          return (
            <Fields.Radio
              label={optionsLabel?.[optionIndex]}
              name={tag}
              initial={initial === optionTag}
              tag={optionTag}
              key={optionTag}
            />
          );
        })}
      </RadioGroup>
    </Intercept>
  );
};

export default MultiRadio;
